/** @format */
import process from "process";
import { apiRequest } from "../Component/Utils/ApiHundler";
const API_BASE_URL = process.env.REACT_APP_API_URL;

export async function getDocPlanADM(token, instanceId, clientId) {
  const apiUrl = `${API_BASE_URL}/admin/document/list/plans`;

  const data = await apiRequest(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify({
      InstanceId: instanceId,
      ClientId: clientId
    }),
  });

  return data.message.list;
}